import { z } from "zod";
import {
  SocialSecurityCardDataSchema,
  SocialSecurityCardContextSchema,
  SocialSecurityCardExtractionSchema,
  type SocialSecurityCardData,
} from "../../../document/document-types/social-security-card";
import type { FieldMessages } from "../../../document/types";
import { createFieldMessagesSchema } from "../../../document/schema";
import { storeResponseSchema } from "../base";
import type { DocumentTypeSchemas } from "../types";

// ===== Internal schemas (not exported) =====

const fieldMessagesSchema = createFieldMessagesSchema(SocialSecurityCardDataSchema);

const warnRequestSchema = z.object({
  data: SocialSecurityCardDataSchema.partial(),
  context: SocialSecurityCardContextSchema,
});

const validateRequestSchema = z.object({
  data: SocialSecurityCardDataSchema.partial(),
  context: SocialSecurityCardContextSchema,
});

// ===== Exported types (for API client) =====

/** Response type for /extract endpoint */
export type ExtractResponse = z.infer<typeof SocialSecurityCardExtractionSchema>;

/** Request body type for /warn endpoint */
export type WarnRequestBody = z.infer<typeof warnRequestSchema>;

/** Response type for /warn endpoint - uses FieldMessages for proper key typing */
export type WarnResponse = FieldMessages<SocialSecurityCardData>;

/** Request body type for /validate endpoint */
export type ValidateRequestBody = z.infer<typeof validateRequestSchema>;

/** Response type for /validate endpoint - uses FieldMessages for proper key typing */
export type ValidateResponse = FieldMessages<SocialSecurityCardData>;

/** Response type for /store endpoint */
export type StoreResponse = z.infer<typeof storeResponseSchema>;

// ===== Exported bundle (source of truth for route registration) =====

/**
 * Bundled schemas for route factory registration
 */
export const SocialSecurityCardSchemas = {
  extractResponse: SocialSecurityCardExtractionSchema,
  warnRequest: warnRequestSchema,
  warnResponse: fieldMessagesSchema,
  validateRequest: validateRequestSchema,
  validateResponse: fieldMessagesSchema,
  storeResponse: storeResponseSchema,
} satisfies DocumentTypeSchemas;
